import axios from "axios";
import { Demande, ParametresDemandeDuplications, ParametresDemandeHorairesPermanents, ParametresDemandeHorairesExceptionnelles, ParametresDemandeMessagesFixe, ResultatDemandeMessage } from '../../Models/Demande/DemandeModels';
import { errorService } from "../Error/ErrorService";
import { URLAPI } from "../../Setting";
import dayjs from "dayjs";
import { jourSemaineFr } from "../../Utils/joursSemaine";
import { DataHorairesExceptionnels, DataHorairesPermanents } from "../../Models/User/UserModels";
// import { MessageService } from "../Message/MessageService";
import { Flux } from "../../Models/Message/MessageModels";
import { FluxService } from "../Message/FluxService";

export interface objetDemandeAPI {
    "dateDemande": string,
    "dateApplication": string,
    "typeDemande": number,
    "fluxes": number[],
    "parametres": any,
    "controles": never[]
}

export function DemandeService(){

    // const addDays = (date:Date, days: number)=>{
    //     var newDate = new Date(date.valueOf());
    //     newDate.setDate(date.getDate() + days);
    //     newDate.setHours(8, 0, 0); //met heure d'application au jour désigné à 8h
    //     return newDate;
    // }

    // GestionMessagesFixes migre cote API

    return{
        //GET Global
        async getDemandes(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const element of data){
                    switch(element['typeDemande']['type']){
                        case 'Permanent':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresHorairesPermanent:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Rotation':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresMessagesRotation:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Fixe':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresMessagesFixe:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'OE':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresHorairesExceptionelles:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Campagne':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresCampagnes:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Duplication':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresDuplications:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Spot':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresSpotExpress:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Calme':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresTempsCalme:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Thematique':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresMusiquesThematiques:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                        case 'Soirées':
                            demandes.push({
                                id:element['id'],
                                dateApplication:element['dateApplication'],
                                dateDemande:element['dateDemande'],
                                typeDemande:element['typeDemande'],
                                parametresSoirees:element['parametres'],
                                controles:element['controles'],
                                fluxes:element['fluxes'],
                                fichiers:element['fichiers']
                            });
                            break;
                    }
                }
            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesStatistiquesAdmin(galec:boolean, cataMidis:boolean, spot:boolean, duplication:boolean, dateDebut:Date, dateFin:Date, token:string){
            let demandes:Demande[]=[]
            let nbLigneTotal=0;
            try {
                if(galec || cataMidis){
                    let maxPages=0;
                    let dataCampagnes:any[]=[];

                    await axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+5+'?page='+1}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    }).then((result)=>{
                        maxPages = result.data['totalPages'];
                        dataCampagnes.push(...result.data['data']);
                        nbLigneTotal+=result.data['totalResultats'];
                    });

                    if(galec){
                        for(const element of dataCampagnes){
                            if(element['parametres']['typeCampagne'].toLowerCase()==='galec')
                                demandes.push({
                                    id:element['id'],
                                    dateApplication:element['dateApplication'],
                                    dateDemande:element['dateDemande'],
                                    typeDemande:element['typeDemande'],
                                    parametresCampagnes:element['parametres'],
                                    controles:element['controles'],
                                    fluxes:element['fluxes'],
                                    fichiers:element['fichiers']
                                });
                        }
                    }
                    if(cataMidis){
                        for(const element of dataCampagnes){
                            if(element['parametres']['typeCampagne'].toLowerCase()==='cata midis')
                                demandes.push({
                                    id:element['id'],
                                    dateApplication:element['dateApplication'],
                                    dateDemande:element['dateDemande'],
                                    typeDemande:element['typeDemande'],
                                    parametresCampagnes:element['parametres'],
                                    controles:element['controles'],
                                    fluxes:element['fluxes'],
                                    fichiers:element['fichiers']
                                });
                        }
                    }

                    if(maxPages!==0)
                        for(let indexPage=2; indexPage<=maxPages; indexPage++){
                            // if(indexPage>maxPages)break;
                            let dataCampagnes:any[]=[];
                            axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+5+'?page='+indexPage}`, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type":"application/ld+json"
                                },
                            }).then((result)=>{
                                dataCampagnes.push(...result.data['data']);
                                if(galec){
                                    for(const element of dataCampagnes){
                                        if(element['parametres']['typeCampagne'].toLowerCase()==='galec')
                                            demandes.push({
                                                id:element['id'],
                                                dateApplication:element['dateApplication'],
                                                dateDemande:element['dateDemande'],
                                                typeDemande:element['typeDemande'],
                                                parametresCampagnes:element['parametres'],
                                                controles:element['controles'],
                                                fluxes:element['fluxes'],
                                                fichiers:element['fichiers']
                                            });
                                    }
                                }
                                if(cataMidis){
                                    for(const element of dataCampagnes){
                                        if(element['parametres']['typeCampagne'].toLowerCase()==='cata midis')
                                            demandes.push({
                                                id:element['id'],
                                                dateApplication:element['dateApplication'],
                                                dateDemande:element['dateDemande'],
                                                typeDemande:element['typeDemande'],
                                                parametresCampagnes:element['parametres'],
                                                controles:element['controles'],
                                                fluxes:element['fluxes'],
                                                fichiers:element['fichiers']
                                            });
                                    }
                                }
                            });
                        }
                }
                if(spot){
                    let maxPages=0;
                    let dataSpotExpress:any[]=[];

                    await axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+6+'?page='+1}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    }).then((result)=>{
                        maxPages = result.data['totalPages'];
                        dataSpotExpress.push(...result.data['data']);
                        nbLigneTotal+=result.data['totalResultats'];
                    });
                    
                    for(const element of dataSpotExpress){
                        demandes.push({
                            id:element['id'],
                            dateApplication:element['dateApplication'],
                            dateDemande:element['dateDemande'],
                            typeDemande:element['typeDemande'],
                            parametresSpotExpress:element['parametres'],
                            controles:element['controles'],
                            fluxes:element['fluxes'],
                            fichiers:element['fichiers']
                        });
                    }

                    if(maxPages!==0)
                        for(let indexPage=2; indexPage<=maxPages; indexPage++){
                            // if(indexPage>maxPages)break;
                            let dataSpotExpress:any[]=[];
                            axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+6+'?page='+indexPage}`, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type":"application/ld+json"
                                },
                            }).then((result)=>{
                                dataSpotExpress.push(...result.data['data']);
                                for(const element of dataSpotExpress){
                                    demandes.push({
                                        id:element['id'],
                                        dateApplication:element['dateApplication'],
                                        dateDemande:element['dateDemande'],
                                        typeDemande:element['typeDemande'],
                                        parametresSpotExpress:element['parametres'],
                                        controles:element['controles'],
                                        fluxes:element['fluxes'],
                                        fichiers:element['fichiers']
                                    });
                                }
                            });
                        }
                }
                if(duplication){
                    let maxPages=0;
                    let dataDupli:any[]=[];

                    await axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+10+'?page='+1}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    }).then((result)=>{
                        maxPages = result.data['totalPages'];
                        dataDupli.push(...result.data['data']);
                        nbLigneTotal+=result.data['totalResultats'];
                    });

                    for(const element of dataDupli){
                        demandes.push({
                            id:element['id'],
                            dateApplication:element['dateApplication'],
                            dateDemande:element['dateDemande'],
                            typeDemande:element['typeDemande'],
                            parametresDuplications:element['parametres'],
                            controles:element['controles'],
                            fluxes:element['fluxes'],
                            fichiers:element['fichiers']
                        });
                    }

                    if(maxPages!==0)
                        for(let indexPage=2; indexPage<=maxPages; indexPage++){
                            // if(indexPage>maxPages)break;
                            let dataDupli:any[]=[];
                            axios.get(`${URLAPI+'demandes/statistiques/'+dayjs(dateDebut).format('YYYY-MM-DD')+'/'+dayjs(dateFin).format('YYYY-MM-DD')+'/'+10+'?page='+indexPage}`, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type":"application/ld+json"
                                },
                            }).then((result)=>{
                                dataDupli.push(...result.data['data']);
                                for(const element of dataDupli){
                                    demandes.push({
                                        id:element['id'],
                                        dateApplication:element['dateApplication'],
                                        dateDemande:element['dateDemande'],
                                        typeDemande:element['typeDemande'],
                                        parametresSpotExpress:element['parametres'],
                                        controles:element['controles'],
                                        fluxes:element['fluxes'],
                                        fichiers:element['fichiers']
                                    });
                                }
                            });
                        }
                }

                const arrayFluxes = await FluxService().getFluxesStatistiquesAdmin(token);
                for(const demande of demandes){
                    const fluxesDem = arrayFluxes.filter(fluxArr=>demande.fluxes.find(fluxDem=>fluxDem.id===fluxArr.id));
                    demande.fluxes = fluxesDem;
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return {demandesFinal:[], nombreTotalLignes:0};
            }
            return {demandesFinal:demandes, nombreTotalLignes:nbLigneTotal};
        },

        //Get par TypeDemande
        async getDemandesHorairesPermanents(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+2}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresHorairesPermanent:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesHorairesPermanentsFlux(idFlux:number, token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/flux/'+idFlux+'/'+2}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresHorairesPermanent:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesDuplications(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+10}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresDuplications:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

                const arrayFluxes = await FluxService().getFluxesLight(token);
                for(const demande of demandes){
                    const fluxesDem = arrayFluxes.filter(fluxArr=>demande.fluxes.find(fluxDem=>fluxDem.id===fluxArr.id));
                    demande.fluxes = fluxesDem;
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesSpotExpress(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+6}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresSpotExpress:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

                const arrayFluxes = await FluxService().getFluxesLight(token);
                for(const demande of demandes){
                    const fluxesDem = arrayFluxes.filter(fluxArr=>demande.fluxes.find(fluxDem=>fluxDem.id===fluxArr.id));
                    demande.fluxes = fluxesDem;
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesMessagesPermanents(token:string){
            let demandes:Demande[]=[]
            try {
                const reponseFixe = await axios.get(`${URLAPI+'demandes/typeDemande/'+3}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataFixe = reponseFixe.data;
                for(const element of dataFixe){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresMessagesFixe:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

                const reponseHabillage = await axios.get(`${URLAPI+'demandes/typeDemande/'+4}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataHabillage = reponseHabillage.data;
                for(const element of dataHabillage){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresMessagesRotation:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesOE(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+1}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresHorairesExceptionelles:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesThematiquesSoirees(token:string){
            let demandes:Demande[]=[]
            try {
                const reponseThematique = await axios.get(`${URLAPI+'demandes/typeDemande/'+7}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataThematique = reponseThematique.data;
                for(const element of dataThematique){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresMusiquesThematiques:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

                const reponseSoirees = await axios.get(`${URLAPI+'demandes/typeDemande/'+8}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataSoirees = reponseSoirees.data;
                for(const element of dataSoirees){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresSoirees:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesTempsCalme(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+9}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresTempsCalme:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesTempsCalmeHistorique(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/tous'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const element of data){
                    if(element['typeDemande']['id']===9)
                        demandes.push({
                            id:element['id'],
                            dateApplication:element['dateApplication'],
                            dateDemande:element['dateDemande'],
                            typeDemande:element['typeDemande'],
                            parametresTempsCalme:element['parametres'],
                            controles:element['controles'],
                            fluxes:element['fluxes'],
                            fichiers:element['fichiers']
                        });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesCampagnes(token:string){
            let demandes:Demande[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'demandes/typeDemande/'+5}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresCampagnes:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }

            } catch (error) {
                errorService().handleError("Erreur obtention Demandes", error);
                return [];
            }
            return demandes;
        },

        async getDemandesCampagnesFlux(idFlux:number, token:string){
            let demandes:Demande[]=[]
            try {
                // dateFinMin ecarte les campagnes terminees : sans elle, trois ans
                // d'historique remontent pour un ecran qui montre les commandes en cours
                const dateFinMin = dayjs(new Date()).format('YYYY-MM-DD');
                const reponse = await axios.get(`${URLAPI+'demandes/flux/'+idFlux+'/'+5+'/'+dateFinMin}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data;
                for(const element of data){
                    demandes.push({
                        id:element['id'],
                        dateApplication:element['dateApplication'],
                        dateDemande:element['dateDemande'],
                        typeDemande:element['typeDemande'],
                        parametresCampagnes:element['parametres'],
                        controles:element['controles'],
                        fluxes:element['fluxes'],
                        fichiers:element['fichiers']
                    });
                }
            } catch (error) {
                errorService().handleError("Erreur obtention Demandes campagnes du flux", error);
                return [];
            }
            return demandes;
        },

        //DELETE Demande
        async deleteDemande(idDemande:number, token:string){
            try {
                const response = await axios.delete(
                    `${URLAPI}demande/${idDemande}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                return response.status;
            } catch (error) {
                errorService().handleError("Erreur suppresion demande", error);
                return 404;
            }
        },

        //Demande FIXE
        async postDemandeFixe(demande:Demande, token:string):Promise<ResultatDemandeMessage>{
            try {
                if(!demande.parametresMessagesFixe){
                    throw new Error('Parametres fixe non initialise')
                }

                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeFixeObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresMessagesFixe,
                    "controles": []
                }

                const reponse = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeFixeObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return {status:reponse.status, refus:[], informations:reponse.data?.['informations'] ?? []};
            } catch (error:any) {
                // 422 : refus metier documente, on remonte le detail par jour sans
                // le journaliser comme une panne technique
                if(error?.response?.status===422 && Array.isArray(error.response.data?.refus)){
                    return {status:422, refus:error.response.data.refus, informations:[]};
                }
                errorService().handleError("Erreur ajout demande message fixe", error);
                return {status:400, refus:[], informations:[]};
            }
        },

        async postDesactivationFixe(demande:Demande, token:string, dateApplication?:Date):Promise<ResultatDemandeMessage>{
            try {
                if(!demande.parametresMessagesFixe){
                    throw new Error('Parametres fixe non initialise')
                }

                // copie : l'objet recu vient du state du composant, on ne le modifie pas
                const parametres = {...demande.parametresMessagesFixe, diffusion:'non'};

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(dateApplication ?? new Date()).format('YYYY-MM-DD');

                let postDemandeFixeObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": parametres,
                    "controles": []
                }

                const reponse = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeFixeObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return {status:reponse.status, refus:[], informations:reponse.data?.['informations'] ?? []};
            } catch (error:any) {
                if(error?.response?.status===422 && Array.isArray(error.response.data?.refus)){
                    return {status:422, refus:error.response.data.refus, informations:[]};
                }
                errorService().handleError("Erreur desactivation message fixe", error);
                return {status:400, refus:[], informations:[]};
            }
        },

        async patchDemandeFixe(demande:Demande, token:string){
            try {
                if(!demande.parametresMessagesFixe){
                    throw new Error('Magasin lié à demande ou paramètres fixe non initilaisé')
                }

                //formattage des dates
                // const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                // const dateApplicationFormatte = dayjs(demande.dateApplication).format('YYYY-MM-DD');
                
                let patchDemandeFixeObjet = {
                    // "dateDemande": dateDemandeFormatte,
                    // "dateApplication": dateApplicationFormatte,
                    "parametres": demande.parametresMessagesFixe,
                }

                const responsePATCHDemande = await axios.patch(
                    `${URLAPI+'demande/'+demande.id}`,
                    patchDemandeFixeObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return responsePATCHDemande.status;
            } catch (error) {
                errorService().handleError("Erreur mise à jour Demande", error);
                return 400;
            }
        },

        //Demande ROTATION
        async postDemandeRotation(demande:Demande, token:string):Promise<ResultatDemandeMessage>{
            try {
                if(!demande.parametresMessagesRotation){
                    throw new Error('Parametres rotation non initialise')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeRotationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresMessagesRotation,
                    "controles": []
                }

                const reponse = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeRotationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return {status:reponse.status, refus:[], informations:reponse.data?.['informations'] ?? []};
            } catch (error:any) {
                // 422 : refus metier documente, on remonte le detail par jour sans
                // le journaliser comme une panne technique
                if(error?.response?.status===422 && Array.isArray(error.response.data?.refus)){
                    return {status:422, refus:error.response.data.refus, informations:[]};
                }
                errorService().handleError("Erreur ajout demande message rotation", error);
                return {status:400, refus:[], informations:[]};
            }
        },

        async postDesactivationRotation(demande:Demande, token:string, dateApplication?:Date):Promise<ResultatDemandeMessage>{
            try {
                if(!demande.parametresMessagesRotation){
                    throw new Error('Parametres rotation non initialise')
                }

                // copie + diffusion forcee : le service est autoritaire, il ne depend plus
                // du fait que l'appelant ait modifie l'objet avant
                const parametres = {...demande.parametresMessagesRotation, diffusion:'non'};

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(dateApplication ?? new Date()).format('YYYY-MM-DD');

                let postDemandeRotationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": parametres,
                    "controles": []
                }

                const reponse = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeRotationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return {status:reponse.status, refus:[], informations:reponse.data?.['informations'] ?? []};
            } catch (error:any) {
                if(error?.response?.status===422 && Array.isArray(error.response.data?.refus)){
                    return {status:422, refus:error.response.data.refus, informations:[]};
                }
                errorService().handleError("Erreur desactivation message rotation", error);
                return {status:400, refus:[], informations:[]};
            }
        },

        async patchDemandeRotation(demande:Demande, token:string){
            try {
                if(!demande.parametresMessagesRotation){
                    throw new Error('Magasin lié à demande ou paramètres rotation non initilaisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(demande.dateApplication).format('YYYY-MM-DD');
                
                let patchDemandeRotationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "parametres": demande.parametresMessagesRotation,
                }

                const reponsePATCHDemande = await axios.patch(
                    `${URLAPI+'demande/'+demande.id}`,
                    patchDemandeRotationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return reponsePATCHDemande.status;
            } catch (error) {
                errorService().handleError("Erreur mise à jour Demande", error);
                return 400;
            }
        },

        //Demande PERMANENT
        async postDemandeHorairePermanent(dataHorairesPermanents:DataHorairesPermanents, token:string){
            //obtention de tous les messages FIXE => faire filtrage daprès requete dans fonction précise + de tous les types de messages fixes
            // => petit algo pour associer chaque message fixe à son type de message fixe si dans la liste => créer un tableau aevc ces messages
            // d'abord ajouter demande horaires puis créer demande pour chauqe message faisant partie des catégories qui doivent ête géres automatiquement

            try {
                let statusFinal = 400;
                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(dataHorairesPermanents.dateApplication).format('YYYY-MM-DD');

                // uniformisation de la casse + coherence journeeContinue / horaires de midi.
                // L'API retient les horaires et non le booleen : on vide les horaires de midi
                // quand la journee est continue, plutot que de les laisser egaux.
                const parametres = dataHorairesPermanents.parametreHoraires.map(horaire=>{
                    const journeeContinue = horaire.journeeContinue || horaire.fermetureMidi===horaire.ouvertureMidi;
                    return {
                        ...horaire,
                        jour: horaire.jour.toLowerCase(),
                        journeeContinue,
                        fermetureMidi: journeeContinue ? '' : horaire.fermetureMidi,
                        ouvertureMidi: journeeContinue ? '' : horaire.ouvertureMidi
                    };
                });

                // une journee non continue sans horaires de midi produirait une divergence
                // avec le booleen, que l'API resoudrait en faveur des horaires
                const jourIncomplet = parametres.find(horaire=>
                    !horaire.journeeContinue
                    && (/^\s*$/.test(horaire.fermetureMidi) || /^\s*$/.test(horaire.ouvertureMidi)));
                if(jourIncomplet){
                    throw new Error('Horaires de midi manquants pour le '+jourIncomplet.jour);
                }

                const arrayflux:number[] = [];
                arrayflux.push(dataHorairesPermanents.flux);
    
                let postDemandeHoraireObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": dataHorairesPermanents.typeDemande,
                    "fluxes": arrayflux,
                    "parametres": parametres,
                    "controles": []
                }
    
                const reponsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeHoraireObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                statusFinal = reponsePOSTDemande.status

                // gestionMessagesFixes migre cote API
                // if(statusFinal===201)statusFinal = await gestionMessagesFixes(dataHorairesPermanents, token);

                return statusFinal;

            } catch (error) {
                errorService().handleError("Erreur ajout demande horaires permanents", error);
                return 400;
            }
        

        },

        async patchDemandeHorairePermanent(dataHorairesPermanents:DataHorairesPermanents, token:string, idDemandeActuelle:number){

            try {
                let statusFinal = 400;
                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(dataHorairesPermanents.dateApplication).format('YYYY-MM-DD');

                // uniformisation de la casse + coherence journeeContinue / horaires de midi.
                // L'API retient les horaires et non le booleen : on vide les horaires de midi
                // quand la journee est continue, plutot que de les laisser egaux.
                const parametres = dataHorairesPermanents.parametreHoraires.map(horaire=>{
                    const journeeContinue = horaire.journeeContinue || horaire.fermetureMidi===horaire.ouvertureMidi;
                    return {
                        ...horaire,
                        jour: horaire.jour.toLowerCase(),
                        journeeContinue,
                        fermetureMidi: journeeContinue ? '' : horaire.fermetureMidi,
                        ouvertureMidi: journeeContinue ? '' : horaire.ouvertureMidi
                    };
                });

                // une journee non continue sans horaires de midi produirait une divergence
                // avec le booleen, que l'API resoudrait en faveur des horaires
                const jourIncomplet = parametres.find(horaire=>
                    !horaire.journeeContinue
                    && (/^\s*$/.test(horaire.fermetureMidi) || /^\s*$/.test(horaire.ouvertureMidi)));
                if(jourIncomplet){
                    throw new Error('Horaires de midi manquants pour le '+jourIncomplet.jour);
                }
    
                let patchDemandeHoraireObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "parametres": parametres,
                }
    
                const reponsePATCHDemande = await axios.patch(
                    `${URLAPI+'demande/'+idDemandeActuelle}`,
                    patchDemandeHoraireObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                statusFinal=reponsePATCHDemande.status;

                // gestionMessagesFixes migre cote API
                // if(statusFinal===200)statusFinal = await gestionMessagesFixes(dataHorairesPermanents, token);

                return statusFinal;
            } catch (error) {
                errorService().handleError("Erreur ajout demande horaires permanents", error);
                return 400;
            }
        },

        //Demande OuvFerm EXCEPTIONNELLES
        async postDemandeHoraireExceptionnelle(dataHorairesExceptionnelles:DataHorairesExceptionnels, token:string){
            try {

                if(!dataHorairesExceptionnelles.flux){
                    throw new Error('Flux non selectionne : la demande ne produirait aucune consigne');
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(dataHorairesExceptionnelles.dateApplication).format('YYYY-MM-DD');

                // jour et date sont derives de dateApplication et recalcules a chaque envoi :
                // aucune desynchronisation possible. Copie par spread pour ne pas muter l'etat React.                
                const p = dataHorairesExceptionnelles.parametreHoraires;
                const journeeContinue = p.fermetureMidi===p.ouvertureMidi;

                const parametres:ParametresDemandeHorairesExceptionnelles = {
                    ...p,
                    fermetureMidi: journeeContinue ? '' : p.fermetureMidi,
                    ouvertureMidi: journeeContinue ? '' : p.ouvertureMidi,
                    jour: jourSemaineFr(dataHorairesExceptionnelles.dateApplication),
                    dateApplication: dayjs(dataHorairesExceptionnelles.dateApplication).format('DD/MM/YYYY')
                };
    
                let postDemandeHoraireObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": dataHorairesExceptionnelles.typeDemande,
                    "fluxes": [dataHorairesExceptionnelles.flux],
                    "parametres": parametres,
                    "controles": []
                }
    
                const reponsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeHoraireObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return reponsePOSTDemande.status
            } catch (error) {
                errorService().handleError("Erreur ajout demande horaires exceptionnels", error);
                return 400;
            }
        

        },

        //Demande Campagnes
        async postDemandeCampagne(demande:Demande, token:string){
            try {
                if(!demande.parametresCampagnes){
                    throw new Error('Magasin lié à demande ou paramètres campagnes non initilaisé')
                }
                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                // une reactivation repart de la demande retrouvee, qui peut etre une
                // desactivation : la diffusion doit etre posee explicitement
                const parametres = {...demande.parametresCampagnes, diffusion:'oui', dateSuppression:''};

                let postDemandeGalecObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": parametres,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeGalecObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return responsePOSTDemande.status;
            } catch (error) {
                errorService().handleError("Erreur ajout demande campagne GALEC", error);
                return 400;
            }
        },


        //utile pour galec ainsi que cata midis
        async postDesactivationDemandeCampagnes(demande:Demande, token:string){
            try {
                if(!demande.parametresCampagnes){
                    throw new Error('Magasin lié à demande ou paramètres campagnes non initilaisé')
                }

                //modif pour mettre date fin sur la date de veille pour la considérer comme 'terminé'
                // demande.parametresCampagnes.dateFin = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                // demande.parametresCampagnes.dateDebut = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                // copie : l'objet recu vient du state du composant
                // les dates de la campagne ne sont plus alterees, c'est diffusion qui porte l'arret
                const parametres = {...demande.parametresCampagnes,
                    diffusion:'non',
                    dateSuppression:dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')};

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeGalecObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": parametres,
                    "controles": []
                }


                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeGalecObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return responsePOSTDemande.status;
            } catch (error) {
                errorService().handleError("Erreur ajout demande campagne GALEC", error);
                return 400;
            }
        },

        //Demande Duplication
        async postDemandeDuplication(demande:Demande, token:string){
            try {
                if(!demande.parametresDuplications){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresDuplications,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        //utilisation reservé au dev => JAMAIS EN PROD
        async patchParametresDemandeDuplication(idDemande:number, parametresModifie:ParametresDemandeDuplications, token:string){
            try {
               
                let patchDemandeDuplicationObjet = {
                    "parametres": parametresModifie,
                }

                const responsePOSTDemande = await axios.patch(
                    `${URLAPI+'demande/'+idDemande}`,
                    patchDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return responsePOSTDemande.status;
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return 400;
            }
        },

        async postDemandeDesactivationDuplication(demande:Demande, flux:Flux, token:string){
            try {
                if(!demande.parametresDuplications){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //modif pour mettre date fin sur la date de veille pour la considérer comme 'terminé'
                // demande.parametresDuplications.dateFin = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                // demande.parametresDuplications.dateDebut = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                const parametres = {...demande.parametresDuplications,
                    diffusion:'non',
                    dateSuppression:dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')};

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": [flux.id],
                    "parametres": parametres,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        async postDemandeReactivationDuplication(demande:Demande, flux:Flux, token:string){
            try {
                if(!demande.parametresDuplications){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                const parametres = {...demande.parametresDuplications, diffusion:'oui', dateSuppression:''};

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": [flux.id],
                    "parametres": parametres,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        //Demande spot express
        async postDemandeSpotExpress(demande:Demande, token:string){
            try {
                if(!demande.parametresSpotExpress){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresSpotExpress,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        async postDemandeDesactivationSpotExpress(demande:Demande, flux:Flux, token:string){
            try {
                if(!demande.parametresSpotExpress){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //modif pour mettre date fin sur la date de veille pour la considérer comme 'terminé'
                // demande.parametresSpotExpress.dateFin = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                // demande.parametresSpotExpress.dateDebut = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                const parametres = {...demande.parametresSpotExpress,
                    diffusion:'non',
                    dateSuppression:dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')};

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": [flux.id],
                    "parametres": parametres,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        async postDemandeReactivationSpotExpress(demande:Demande, flux:Flux, token:string){
            try {
                if(!demande.parametresSpotExpress){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                const parametres = {...demande.parametresSpotExpress, diffusion:'oui', dateSuppression:''};

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": [flux.id],
                    "parametres": parametres,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        //Demande Temps Calme
        async postDemandeTempsCalme(demande:Demande, token:string){
            try {
                if(!demande.parametresTempsCalme){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresTempsCalme,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        async postDemandeDesactivationTempsCalme(demande:Demande, token:string){
            try {
                if(!demande.parametresTempsCalme){
                    throw new Error('Paramètres temps calme non initialisé')
                }

                //modif pour mettre diffsuion sur non et date desac
                demande.parametresTempsCalme.forEach(param=>{
                    param.diffusion='non'; 
                    param.dateSuppression=dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                    param.idDemandeOriginel=demande.id;
                });

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresTempsCalme,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        //Demande Musiques thematiques
        async postDemandeThematiques(demande:Demande, token:string){
            try {
                if(!demande.parametresMusiquesThematiques){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                // const dateApplicationFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD');
                const dateApplicationFormatte = dayjs(demande.dateApplication).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresMusiquesThematiques,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },
       
        //Demande Soirees
        async postDemandeSoirees(demande:Demande, token:string){
            try {
                if(!demande.parametresSoirees){
                    throw new Error('Paramètres duplications non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(demande.dateDemande).format('YYYY-MM-DD HH:mm:ss');
                const dateApplicationFormatte = dayjs(demande.dateApplication).format('YYYY-MM-DD');

                let postDemandeDuplicationObjet = {
                    "dateDemande": dateDemandeFormatte,
                    "dateApplication": dateApplicationFormatte,
                    "typeDemande": demande.typeDemande.id,
                    "fluxes": demande.fluxes.map(flux=>flux.id),
                    "parametres": demande.parametresSoirees,
                    "controles": []
                }

                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeDuplicationObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },

        //Demande Musiques thematiques & Soirées
        async postDemandeDesactivationThematiquesSoirees(demande:Demande, token:string){
            try {
                if(!demande.parametresMusiquesThematiques && !demande.parametresSoirees){
                    throw new Error('Paramètres soirées et thématiques non initialisé')
                }

                //formattage des dates
                const dateDemandeFormatte = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                // const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');
                // la desactivation doit s'appliquer au plus tot a la date de la demande annulee,
                // sinon l'activation resterait la plus recente
                /*
                const dateApplicationFormatte = dayjs(demande.dateApplication).isAfter(dayjs(new Date()), 'day')
                    ? dayjs(demande.dateApplication).format('YYYY-MM-DD')
                    : dayjs(new Date()).format('YYYY-MM-DD');
                */
                // la suppression porte la date du jour : le departage avec l'activation
                // se fait sur dateDemande cote API
                const dateApplicationFormatte = dayjs(new Date()).format('YYYY-MM-DD');
                let postDemandeThematiqueSoireeObjet:any;

                //modif pour mettre diffsuion sur non et date desac et idDemandeDesac
                if(demande.parametresMusiquesThematiques){
                    const parametres = {...demande.parametresMusiquesThematiques,
                            diffusion:'non',
                            dateSuppression:dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                            idDemandeOriginel:demande.id};

                    postDemandeThematiqueSoireeObjet = {
                        "dateDemande": dateDemandeFormatte,
                        "dateApplication": dateApplicationFormatte,
                        "typeDemande": demande.typeDemande.id,
                        "fluxes": demande.fluxes.map(flux=>flux.id),
                        "parametres": parametres,
                        "controles": []
                    }
                }

                if(demande.parametresSoirees){
                    const parametres = {...demande.parametresSoirees,
                            diffusion:'non',
                            dateSuppression:dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                            idDemandeOriginel:demande.id};

                    postDemandeThematiqueSoireeObjet = {
                        "dateDemande": dateDemandeFormatte,
                        "dateApplication": dateApplicationFormatte,
                        "typeDemande": demande.typeDemande.id,
                        "fluxes": demande.fluxes.map(flux=>flux.id),
                        "parametres": parametres,
                        "controles": []
                    }
                }


                const responsePOSTDemande = await axios.post(
                    `${URLAPI+'demande'}`,
                    postDemandeThematiqueSoireeObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return {status:responsePOSTDemande.status, id:responsePOSTDemande.data['id']};
            } catch (error) {
                errorService().handleError("Erreur ajout demande Duplication", error);
                return {status:400, id:0};
            }
        },
    }
}
